import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import getProgressBarColor from '../../Utils/getProgressBarColor';
import DescriptionBanner from '../DescriptionBanner';
import TotalsSummaryCard from '../TotalSummaryCard';
import DynamicTable from '../UI/DynamicTable';
export default function BrowsingAngelTable({
  browsingAngelStats,
  isVisibleTotValue = true,
  viewDescriptionBanner = true,
  disableForEnterprise
}) {
  const { t } = useTranslation();
  const [search, setSearch] = useState('');
  const filteredData = browsingAngelStats?.endpoint_stats.filter(item => {
    const lower = search.toLowerCase();
    return (item.email ?? '').toLowerCase().includes(lower);
  }) || [];
  const totalValue = [
    { label: t('totalEndpoints'), value: browsingAngelStats?.company_stats.total_endpoints ?? 0 },
    { label: t('totalUrlsExamined'), value: browsingAngelStats?.company_stats.total_urls_examined ?? 0 },
    { label: t('totalUrlsBlocked'), value: browsingAngelStats?.company_stats.blocked_urls ?? 0 },
    { label: t('totalUrlsBypassed'), value: browsingAngelStats?.company_stats.by_passed_by_user ?? 0 },
    {
      label: t('avgProtection'),
      value: `${browsingAngelStats?.company_stats.protection_effectiveness ?? 0}`,
      suffix: '%'
    }
  ];

  return (
    <div>
      {viewDescriptionBanner && (
        <div className="mb-6">
          <DescriptionBanner
            title={t('browsingAngelStatus')}
            description={t('browsingAngelStatusDesc')}
          />
        </div>
      )}

      {isVisibleTotValue && <TotalsSummaryCard items={totalValue} />}
      {!disableForEnterprise && (
        <div className='mt-6'>
          {filteredData && filteredData.length > 0 ? (
            <DynamicTable
              data={filteredData}
              customColumnsMap={[
                {
                  field: 'email',
                  label: t('email'),
                  width: 'w-48'
                },
                {
                  field: 'blocked_urls',
                  label: t('urlsBlocked'),
                  width: 'w-48'
                },
                {
                  field: 'by_passed_by_user',
                  label: t('urlsBypassed'),
                  width: 'w-48'
                },
                {
                  label: t('protectionRate'),
                  width: 'w-48',
                  align: 'left',
                  render: (row) => (
                    <div className="flex items-center gap-2">
                      {row.protection_effectiveness}%
                      <div className="w-full bg-gray-300 h-3 rounded">
                        <div
                          className={`${getProgressBarColor(100 - row.protection_effectiveness)} h-3 rounded`}
                          style={{ width: `${row.protection_effectiveness || 0}%` }}
                        />
                      </div>
                    </div>
                  )
                },
              ]}
              searchTerm={search}
              onSearchChange={setSearch}
              searchKeys={['asset', 'tipo_asset']}
              enableRowSelection={false}
              showSearchBar={true}
              maxHeight="40rem"
            />
          ) : (
            <div className='text-center py-8 text-gray-500'>
              Nessun dato disponibile da caricare in questa sezione
            </div>
          )}
        </div>
      )}
    </div>
  );
}
